import * as _ from 'underscore';
import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField'; //LL: 01.10.18

import * as appTheme from '../../../../_common/platform/ts/appTheme';

import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

declare var require: any;

import { ThemePreview } from '../../tsx/ThemePreview';

var template = require('!!raw-loader!pdc-widget-clock/src/mainTheme.template.css').default;
template;

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: 'widget-clock',
            name: 'Clock',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-clock',

            themeType: 'Widget Clock',
            visibility: ['application', 'workspace', 'pdc-widget-clock']
        }
    ]);

    appTheme.registerVars([
        {
            id: 'widget-clock-text-color',
            param: new ColorBoxField(
                glob,
                'Clock Widget Text Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: 'widget-clock',
            deps: ['gray-base']
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-clock']);

    _init.push(glob);
}
